import { render, staticRenderFns } from "./ThreadAvatar.vue?vue&type=template&id=3431f420&scoped=true&"
import script from "./ThreadAvatar.vue?vue&type=script&lang=js&"
export * from "./ThreadAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ThreadAvatar.vue?vue&type=style&index=0&id=3431f420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3431f420",
  null
  
)

export default component.exports